import React, { forwardRef, useRef, useImperativeHandle } from "react";

//https://stackoverflow.com/questions/37949981/call-child-method-from-parent
const LingoliaScrapper = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    // getAlert() {
    //   alert("getAlert from Child");
    // }

    scrape_component() {
      const cheerio = require("cheerio");
      const request = require("request");
    //  alert("lingolia");
      //alert(props.SearchedWord );
      //   alert(props.Language );

      var return_list = [];
      var return_short = [];

      let url = "";
      if (props.Language == "Spanish") {
        url =
          "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/spanish-english/" +
          props.SearchedWord;
      } else if (props.Language == "German") {
        url =
          // "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/german-english/" +
        //  "https://uplifted-stream-263318.ey.r.appspot.com/https://context.reverso.net/translation/german-english/" +
                  url = "http://localhost:8080/http://localhost:4000/file";
      //    props.SearchedWord;
      } else if (props.Language == "French") {
        // url =
        //   "https://uplifted-stream-263318.ey.r.appspot.com/https://www.linguee.com/english-french/search?source=french&query=" +
        //   props.SearchedWord;

         url =
          "https://uplifted-stream-263318.ey.r.appspot.com/https://www.wordreference.com/fren/" +
          props.SearchedWord;
      }
      //else {url="https://context.reverso.net/translation/english-spanish/" + props.SearchedWord }
      else {
        url =
          // "https://uplifted-stream-263318.ey.r.appspot.com/https://www.linguee.com/english-french/search?source=english&query=" +
          "https://uplifted-stream-263318.ey.r.appspot.com/https://www.collinsdictionary.com/dictionary/english-french/" +
          props.SearchedWord;
      }
      //alert(url);
      request(
        {
          method: "GET",
          url: url,
        },
        (err, res, body) => {
          if (err) return console.error(err);
          let $ = cheerio.load(body);
          console.log($);
          var count = 0;

          //    $(".type-example").each(function (i, e) {
          $(".s20").each(function (i, e) {
            count++;
            //    alert($(this).text());
            var text = "";

            var index = text.indexOf("[");
            var part1 = "";
            var part2 = "";
            if (index > 0) {
              part1 = text.slice(0, index - 1);
            }
            index = text.indexOf("]");
            if (index > 0) {
              part2 = text.slice(index + 1, text.length);
            }
            if ($(this).childNodes != undefined) {
              text += $(this).childNodes[1].text().toString().trim();
              text += $(this).childNodes[1].textContent.toString().trim();
              text += $(this).childNodes[1].nodeValue.toString().trim();
              //  console.log();
              // for (var i = 0; i < $(this).childNodes.length; ++i){
              //   if ($(this).childNodes[i].nodeType === Node.TEXT_NODE)
              //   text += $(this).childNodes[i].textContent;
              // }
            }

            // for (var element in $(this)) {
            //   if (element.nodeType == Node.TEXT_NODE) {
            //       text += element.nodeValue;

            //   }
            //   }
            if (text != undefined && text != "") {
              //   text = text.toString().trim();
              return_list.push(text);
            }
          });

          $(".FrEx, .ToEx").each(function (i, e) {
            count++;
            //  alert($(this).text());
            var text = $(this).text();
            text = text.toString().trim();
            return_list.push(text);
          });

          $(".ToWrd").each(function (i, e) {
            if (i > 5) {
              return;
            }

            var text = $(this).text();
            text = text.toString().trim();
            return_short.push(text);
          });

          props.handleScrap(
            return_list,
            props.Language,
            return_short,
            "lingolia"
          );
        }
      );
    },
  }));

  return <div></div>;
});

export default LingoliaScrapper;
